<template>
  <div>
    <div class="input-dropdown__input-container">
      <input class="input-dropdown__input" type="text" v-model="inputModel" @keyup.enter="apply()">
      <div class="input-dropdown__clear-button" @click.stop="inputModel = ''" v-if="inputModel"></div>
      <base-material-design-icon class="input-dropdown__search-button" icon="search" v-else></base-material-design-icon>
    </div>
  </div>
</template>

<script>
  import BaseMultiSelectSortableHeader from "./BaseMultiSelectSortableHeader";

/**
   * component is used in {@link BaseMultiSelectSortableHeader} as filter for string value like URL
   */
export default {
  name: 'BaseInputFilterDropdown',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    propertyName: {
      type: String,
      required: true
    },
    // modelValue reflects whether something is applied in this component or not to change style of parent object
    modelValue: {
      default: false
    },
    // values set outside component
    predefinedFilter: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      inputModel: null,
      appliedData: null
    }
  },
  watch: {
    /**
     * set earlier created filters into component
     * */
    predefinedFilter: {
      handler (value) {
        if (value) {
          this.inputModel = value
          this.appliedData = this.inputModel
          this.$emit('change', this.somethingIsApplied())
        }
      },
      immediate: true
    }
  },
  methods: {
    cancel () {
      this.inputModel = null
      this.appliedData = null
      this.$emit('change', this.somethingIsApplied())
    },
    apply () {
      this.$emit('apply', this.inputModel)
      this.appliedData = this.inputModel
    },
    /**
     * invoked from parent component when component is opened/closed
     * @param isOpened
     */
    reset (isOpened) {
      if (isOpened) {
        this.inputModel = this.appliedData
      } else {
        this.$emit('change', this.somethingIsApplied())
      }
    },
    somethingIsApplied () {
      return Boolean(this.appliedData)
    }
  }
}
</script>

<style scoped lang="scss">
  .input-dropdown {
    position: relative;
    flex: 1 1 100%;
    height: 100%;

    &__clear-button,
    &__search-button {
      position: absolute;
      top: 12px;
      right: 8px;
      width: 16px;
      height: 16px;
      background-color: transparent;
      color: $rfx-dark-march;
    }

    &__clear-button {
      cursor: pointer;
      &:hover {
        opacity: 1;
      }

      &:before, &:after {
        position: absolute;
        left: 7px;
        top: 3px;
        content: '';
        height: 12px;
        width: 2px;
        background-color: currentColor;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }
    }

    &__input-container {
      position: relative;
      display: flex;
      padding: 0 10px 10px 15px;
    }

    &__sort-container {
    flex: 0 0 14px;
    justify-content: center;
    display: flex;
    align-items: center;
    text-align: center;
    padding-top: 5px;
    }

    &__input {
      height: 20px;
      flex: 1 1 100%;
      outline: none;
      border: none;
      border-bottom: 1px solid $rfx-bright-blue;
      padding: 10px 0;
    }
  }

</style>
